module.exports = __webpack_public_path__ + "static/media/workPvcCeilings3.4642d411.jpg";